export const petrol = '#002E3C';
export const yellow = '#FFD700';
export const grey = '#F1EFED';
export const darkYellow = '#F6BE00';
export const darkGrey = '#828282';
